// extracted by mini-css-extract-plugin
export default {"content":"aok84p1ulIC8MLJRRd1k","header":"m9kNUtgGMpDIXWxZEXBM","title":"bnTqNackSpIjzGtHncO3","body":"nxTyqdULX_f6MCQw6qZ0","paragraph":"Z3NJ4OyKfBCdVxus5qp0"};